module.exports = __webpack_public_path__ + "img/m_expanbg.04e66ef2.jpg";